export function buildPortfoliosPageQueryV1(workspaceId: number, strategyId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Portfolios.Queries.PortfoliosPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'StrategyId': strategyId,
	}
}

export function buildPnlPageQueryV1(workspaceId: number, tchProjectId: number, viewDefId: string, pnlId: string, applyBenefitsConfidenceFactor: boolean, denomination: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Portfolios.Queries.PnlPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
		'ViewDefId': viewDefId,
		'PnlId': pnlId,
		'ApplyBenefitsConfidenceFactor': applyBenefitsConfidenceFactor,
		'Denomination': denomination,
	}
}


export function buildLinkeableTchProjectsByWorkspaceIdQueryV1(workspaceId: number)
{
	return {
		'$type': 'TCh.Domain.Quest.Portfolios.Queries.LinkeableTchProjectsByWorkspaceIdQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
	}
}



export function buildPortfolioSettingsQueryV1(workspaceId: number, tchProjectId: number)
{ 
	return {
		'$type': 'TCh.Domain.Quest.Portfolios.Queries.PortfolioSettingsQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
	}
}


export function buildSpreadsheetImportMappingQueryV1(workspaceId: number, tchProjectId: number, blobId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Portfolios.Queries.SpreadsheetImportMappingQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
		'BlobId': blobId,
	}
}

export function buildPortfolioPlanningModuleStatusQueryV1(workspaceId: number, tchProjectId: number)
{
	return {
		'$type': 'TCh.Domain.Quest.Portfolios.Queries.PortfolioPlanningModuleStatusQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
	}
}




export function buildAllProjectsPageQueryV1(workspaceId: number, tchProjectId: number)
{
	return {
		'$type': 'TCh.Domain.Quest.Portfolios.Queries.AllProjectsPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
	}
}

export function buildProposedProjectsPageQueryV1(workspaceId: number, tchProjectId: number)
{
	return {
		'$type': 'TCh.Domain.Quest.Portfolios.Queries.ProposedProjectsPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
	}
}

export function buildScheduledProjectsPageQueryV1(workspaceId: number, tchProjectId: number)
{
	return {
		'$type': 'TCh.Domain.Quest.Portfolios.Queries.ScheduledProjectsPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
	}
}

export function buildStartedProjectsPageQueryV1(workspaceId: number, tchProjectId: number)
{
	return {
		'$type': 'TCh.Domain.Quest.Portfolios.Queries.StartedProjectsPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
	}
}

export function buildFinishedProjectsPageQueryV1(workspaceId: number, tchProjectId: number)
{
	return {
		'$type': 'TCh.Domain.Quest.Portfolios.Queries.FinishedProjectsPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
	}
}